import React from 'react'
import type { HandlingStatus } from '../../types/inbox'
import { HANDLING_STATUS_OPTIONS, handlingStatusBadgeClass, handlingStatusLabel } from '../../lib/inboxFilters'

interface HandlingStatusSelectProps {
  value: HandlingStatus
  waitingUntil: string | null
  onChange: (status: HandlingStatus, waitingUntil?: string | null) => void
  disabled?: boolean
  compact?: boolean
  hideBadge?: boolean
}

export function HandlingStatusSelect({
  value,
  waitingUntil,
  onChange,
  disabled,
  compact,
  hideBadge,
}: HandlingStatusSelectProps) {
  return (
    <div className={`flex items-center gap-2 ${compact ? '' : 'flex-wrap'}`}>
      <select
        value={value}
        disabled={disabled}
        onChange={(e) => {
          const next = e.target.value as HandlingStatus
          if (next === 'waiting') {
            const tomorrow = new Date()
            tomorrow.setDate(tomorrow.getDate() + 1)
            tomorrow.setHours(17, 0, 0, 0)
            onChange(next, waitingUntil || tomorrow.toISOString())
          } else {
            onChange(next, null)
          }
        }}
        className={`border border-gray-200 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 ${
          compact ? 'px-2 py-1 text-[11px]' : 'px-2.5 py-1.5 text-xs'
        }`}
      >
        {HANDLING_STATUS_OPTIONS.map((s) => (
          <option key={s} value={s}>
            {handlingStatusLabel(s)}
          </option>
        ))}
      </select>
      {value === 'waiting' && (
        <input
          type="datetime-local"
          disabled={disabled}
          value={waitingUntil ? waitingUntil.slice(0, 16) : ''}
          onChange={(e) => onChange('waiting', e.target.value ? new Date(e.target.value).toISOString() : null)}
          className={`border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 ${
            compact ? 'px-2 py-1 text-[11px]' : 'px-2.5 py-1.5 text-xs'
          }`}
        />
      )}
      {!hideBadge && (
        <span
          className={`inline-flex px-2 py-0.5 rounded-full text-[10px] font-medium ${handlingStatusBadgeClass(value)}`}
        >
          {handlingStatusLabel(value)}
        </span>
      )}
    </div>
  )
}
